import { render } from "./MergeButton.vue?vue&type=template&id=6d8c5274&scoped=true&ts=true"
import script from "./MergeButton.vue?vue&type=script&lang=ts"
export * from "./MergeButton.vue?vue&type=script&lang=ts"

import "./MergeButton.vue?vue&type=style&index=0&id=6d8c5274&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8c5274"]])

export default __exports__